import {ApiException} from '@/interfaces/apiException';
import {AxiosError} from 'axios';

export function throwException(
    message: string,
    status: number,
    response: string,
    headers: {[key: string]: any},
    result?: any
): any {
    throw new ApiException(message, status, response, headers, result);
}

export function isAxiosError(obj: any | undefined): obj is AxiosError {
    return obj && obj.isAxiosError === true;
}
